import { useState } from "react";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "../../lib/api";
import { cx } from "../../lib/format";

export const Newsletter = ({ variant = "band", source = "site", id }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, source });
      setState("done");
      toast.success(data.message);
    } catch (err) {
      setState("idle");
      toast.error(errorMessage(err));
    }
  };

  const form = state === "done" ? (
    <p className="flex items-center gap-2 text-sm font-semibold text-ab-accent" data-testid="newsletter-success">
      <Check size={18} /> You're in. Look out for your first weekly tips.
    </p>
  ) : (
    <form onSubmit={submit} className="flex w-full flex-col gap-3 sm:flex-row" data-testid="newsletter-form">
      <label htmlFor={`nl-${source}`} className="sr-only">Email address</label>
      <input id={`nl-${source}`} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="input-ab sm:flex-1" data-testid="newsletter-email-input" />
      <button type="submit" disabled={state === "loading"} className="btn-primary disabled:opacity-60" data-testid="newsletter-submit-button">
        {state === "loading" ? "Joining…" : "Join Free"}
      </button>
    </form>
  );

  if (variant === "inline") {
    return (
      <section id={id} aria-labelledby={`nl-h-${source}`} className="card-ab bg-ab-warm p-6 sm:p-8" data-testid="newsletter-inline">
        <p className="eyebrow">Newsletter</p>
        <h2 id={`nl-h-${source}`} className="mt-2 font-serif text-2xl font-semibold">Get Practical Tips Every Week</h2>
        <p className="mt-2 text-sm text-ab-muted">Smart shopping, home, food, travel and everyday ideas delivered once a week.</p>
        <div className="mt-5">{form}</div>
        <p className="mt-3 text-xs text-ab-subtle">No spam. Unsubscribe any time.</p>
      </section>
    );
  }

  return (
    <section id={id || "newsletter"} aria-labelledby="newsletter-heading" className={cx("relative overflow-hidden rounded-3xl bg-[#1E1E1E] px-6 py-14 text-white sm:px-12 lg:px-16", variant === "band" && "grain")} data-testid="newsletter-band">
      <div className="pointer-events-none absolute -right-20 -top-24 h-72 w-72 rounded-full bg-primary/40 blur-3xl" />
      <div className="relative grid items-center gap-10 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em] text-white/70"><Mail size={12} /> Weekly newsletter</span>
          <h2 id="newsletter-heading" className="mt-5 font-serif text-3xl font-semibold leading-tight sm:text-4xl">Get Practical Tips Every Week</h2>
          <p className="mt-4 max-w-md text-white/70">Smart shopping, home, food, travel and everyday ideas delivered once a week. Short, useful, no pressure.</p>
        </div>
        <div className="[&_.input-ab]:border-white/15 [&_.input-ab]:bg-white/10 [&_.input-ab]:text-white [&_.input-ab]:placeholder:text-white/40">{form}<p className="mt-3 text-xs text-white/40">One email a week. Unsubscribe any time.</p></div>
      </div>
    </section>
  );
};
